import { INavigationItem } from '@components/Layouts/Layout/Layout';
import cx from 'classnames';
import React, { useState } from 'react';
import {
	Accordion,
	AccordionItem,
	AccordionItemButton,
	AccordionItemHeading,
	AccordionItemPanel,
} from 'react-accessible-accordion';

import { GLOBAL_NAVIGATION_SECONDARY } from '../../constants/GlobalNavigation';
import { Cross, Toggle } from '../Icon';
import NavigationPanel from './NavigationPanel';
import * as styles from './SocketNavigation.module.css';

const SocketNavigation = ({
	navigation,
	careers,
}: {
	navigation: INavigationItem[];
	careers: boolean;
}) => {
	const [accordionOpen, setAccordionOpen] = useState(false);

	const isBrowser = typeof window !== 'undefined';

	if (isBrowser) {
		accordionOpen
			? document.body.classList.add('lock-accordion')
			: document.body.classList.remove('lock-accordion');
	}

	return (
		<div className={cx(styles.navigation, styles.socket)}>
			<div className={styles.layout}>
				{navigation.map(
					(
						{
							label,
							globalNavigation,
						}: { label: string; globalNavigation: [] },
						key: number
					) => {
						if (!globalNavigation) return null;

						return (
							<Accordion
								key={key}
								allowZeroExpanded
								onChange={() => setAccordionOpen(!accordionOpen)}
							>
								<AccordionItem>
									<AccordionItemHeading>
										<AccordionItemButton className={styles.button}>
											<div className={styles.toggleIcon}>
												<Toggle />
											</div>
											<div className={styles.crossIcon}>
												<Cross />
											</div>
											{label}
										</AccordionItemButton>
									</AccordionItemHeading>
									<AccordionItemPanel className={styles.panel}>
										<NavigationPanel
											subMenus={globalNavigation}
											accordionOpen={accordionOpen}
											socket
										/>
									</AccordionItemPanel>
								</AccordionItem>
							</Accordion>
						);
					}
				)}
				<nav className={styles.secondaryNav}>
					<ul className={styles.secondaryNavList}>
						{GLOBAL_NAVIGATION_SECONDARY.map(
							({ label, to }: { label?: string; to?: string }, i: number) => {
								if (!careers && label === 'Careers') {
									return null;
								} else {
									return (
										<li key={i}>
											<a href={to}>{label}</a>
										</li>
									);
								}
							}
						)}
					</ul>
				</nav>
			</div>
		</div>
	);
};

export default SocketNavigation;
